import { createContext, useContext, type ReactNode } from 'react';

// Pages like ProductsList / PriceImports are reused from BOTH the admin nav
// (mounted at /products, /prices/...) and the seller workspace
// (/workspace/products, /workspace/prices/...). Hard-coding absolute URLs
// inside those pages would break navigation in the other context, so the
// context tells them which prefix to prepend.

const BasePathContext = createContext<string>('');

export function BasePathProvider({ value, children }: { value: string; children: ReactNode }) {
  return <BasePathContext.Provider value={value}>{children}</BasePathContext.Provider>;
}

export function useBasePath() {
  return useContext(BasePathContext);
}

/** Compose a path under the current base. `path` should start with '/'. */
export function withBase(base: string, path: string) {
  if (!path.startsWith('/')) path = '/' + path;
  return (base || '') + path;
}
